import bulkBonuses from "./bulkBonuses.component";
import bulkBonusesUrls from "./bulkBonuses.urls";
import BulkBonusesTransforms from "./bulkBonuses.transforms";

const bulkBonusesModule = angular
  .module("app.components.bulkBonuses", [])
  .component("bulkBonusesPage", bulkBonuses)
  .service("BulkBonusesTransforms", BulkBonusesTransforms)
  .config(bulkBonusesUrls);

export default bulkBonusesModule;



// WEBPACK FOOTER //
// ./src/pages/bulkBonuses/bulkBonuses.module.js